(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerPopUpController', CompanyCustomerPopUpController);

    CompanyCustomerPopUpController.$inject = ['$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$uibModalInstance', '$stateParams'];

    function CompanyCustomerPopUpController($scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $uibModalInstance, $stateParams) {

        var vm = this;
        vm.companyCustomer = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = false;
        vm.customerFormData = null;
        vm.columnCount = null;
        vm.cancel = cancel;
        vm.mode = 'NEW';
        vm.isPopUp = true;

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');

            if ($scope.$resolve && $scope.$resolve.formData) {
                if ($scope.$resolve.formData.mode)
                    vm.mode = $scope.$resolve.formData.mode;
                if ($scope.$resolve.formData.isPopUp != null)
                    vm.isPopUp = $scope.$resolve.formData.isPopUp;
            }


        }

        function save() {
            vm.isSaving = true;

            if (vm.companyCustomer.id !== null) {
                CompanyCustomerCustom.updateCompanyCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                if (vm.companyCustomer.customer !== null) {
                    CompanyCustomerCustom.addNewCustomer().save(vm.companyCustomer, onSaveSuccess, onSaveError);
                }

            }


            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                // $scope.$emit('tikonApp:companyCustomerUpdate', result);
                $uibModalInstance.close(result);
                // $state.go('company-customer.edit', {id: result.id});

                // loadAll();


            }

        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
